/*
 * components/CallComponent/ConnectingCallLoader.ts
 * Anvilo, Inc.
 *
 * This is a modal loading component. Visible while connecting to the call.
 *
 * Created by Artem Yefimenko on 12/05/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import React from "react";
import { Loader } from "semantic-ui-react";

import WholeCoverMask from "../modal/WholeCoverMask";

import uiString from "../../constants/uiString";

function ConnectingCallLoader() {
  return (
    <WholeCoverMask>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Loader active />
        <div style={{ paddingTop: "70px" }}>
          <div>{uiString.CALL_CONNECTING}</div>
        </div>
      </div>
    </WholeCoverMask>
  );
}

export default ConnectingCallLoader;
